import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export default function CategoryCard({ slug, name, description, icon, count }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300/60 hover:bg-background-100 transition-all cursor-pointer"
    >
      <div className="flex items-center gap-3 mb-3">
        <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
          <i className={`${icon} text-lg`}></i>
        </span>
        <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
      </div>
      <p className="text-sm text-foreground-500 leading-relaxed mb-3 flex-1">
        {description}
      </p>
      <span className="text-xs text-foreground-400">
        {count} 款游戏
      </span>
    </Link>
  );
}